<template>
  <WdsAlert v-if="hasContent" class="notice-item" icon :info="isInfo" :warning="!isInfo">
    <template #default>
      <div class="tw-flex tw-justify-between">
        <slot name="head" />
        <slot name="icon" />
      </div>
    </template>
    <template #description>
      <div class="tw-mt-2">
        <slot name="body" />
        <div v-if="status || $slots.status" class="tw-mt-2">
          <slot name="status">
            <span v-if="status" class="f-500">Status: {{ status }}</span>
          </slot>
        </div>
      </div>
    </template>
    <template #footer>
      <slot name="action">
        <a v-if="hasButtonProps" :href="buttonUrl">
          <WdsButton
            :secondary="isInfo"
            sm
            type="button"
            :warning="!isInfo"
            data-test="actionButton"
          >
            {{ buttonText }}
          </WdsButton>
        </a>
      </slot>
    </template>
  </WdsAlert>
</template>

<script setup>
import { computed, defineProps, useSlots } from 'vue'
import { WdsAlert, WdsButton } from '@worksome/wds-components'

const props = defineProps({
  buttonUrl: {
    type: String,
    default: '',
  },
  buttonText: {
    type: String,
    default: '',
  },
  info: {
    type: Boolean,
    default: false,
  },
  status: {
    type: String,
    default: '',
  },
  completed: {
    type: Boolean,
    default: false,
  },
})

const slots = useSlots()

const hasButtonProps = computed(() => props.buttonUrl && props.buttonText)
const hasContent = computed(() => {
  const { action = null, body = null, head = null, icon = null } = slots
  return action !== null || body !== null || head !== null || icon !== null || hasButtonProps.value
})
const isInfo = computed(() => props.info || props.completed)
</script>

<style lang="scss">
.notice-item {
  .notice-item + & {
    @apply tw-mt-4;
  }
}
</style>
